import { api } from '../apis/constants';
import { Collection, CollectionFilter, CollectionFormData, CollectionResponse, CollectionsListResponse, DetailedCollection, DetailedCollectionResponse, CollectionOrderUpdateRequest } from '../types/collections';

// Lấy danh sách collections
const getCollections = async (filter: CollectionFilter = {}): Promise<CollectionsListResponse> => {
  try {
    const response = await api.get('/collections', { params: filter });
    return response.data;
  } catch (error) {
    console.error('Error fetching collections:', error);
    throw error;
  }
};

// Lấy collection theo ID
const getCollectionById = async (id: string): Promise<CollectionResponse> => {
  try {
    const response = await api.get(`/collections/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching collection:', error);
    throw error;
  }
};

// Lấy collection chi tiết với products, sections, news đã populate
const getDetailedCollection = async (id: string): Promise<DetailedCollectionResponse> => {
  try {
    const response = await api.get(`/collections/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching detailed collection:', error);
    throw error;
  }
};

// Tạo collection mới
const createCollection = async (data: CollectionFormData): Promise<any> => {
  try {
    return await api.post('/collections', data);
  } catch (error) {
    console.error('Error creating collection:', error);
    throw error;
  }
};

// Cập nhật collection
const updateCollection = async (id: string, data: Partial<CollectionFormData>): Promise<Collection> => {
  try {
    return await api.patch(`/collections/${id}`, data);
  } catch (error) {
    console.error('Error updating collection:', error);
    throw error;
  }
};

// Xóa collection
const deleteCollection = async (id: string): Promise<void> => {
  try {
    return await api.delete(`/collections/${id}`);
  } catch (error) {
    console.error('Error deleting collection:', error);
    throw error;
  }
};

// Cập nhật vị trí collections
const updateCollectionPositions = async (data: CollectionOrderUpdateRequest): Promise<any> => {
  try {
    const response = await api.patch('/collections/order/update', data);
    return response.data;
  } catch (error) {
    console.error('Error updating collection positions:', error);
    throw error;
  }
};

export interface CollectionSelector {
  _id: string;
  name: string;
  images: string[];
  status: string;
}

export interface CollectionsSelectorResponse {
  status: string;
  data: CollectionSelector[];
}

const getCollectionSelectors = async (): Promise<CollectionsSelectorResponse> => {
  try {
    const response = await api.get('/collections/selectors');
    return response.data;
  } catch (error) {
    console.error('Error fetching collection selectors:', error);
    throw error;
  }
};

const collectionService = {
  getCollections,
  getCollectionById,
  getDetailedCollection,
  createCollection,
  updateCollection,
  deleteCollection,
  getCollectionSelectors,
  updateCollectionPositions,
};

export default collectionService; 